var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.synopsis)?_c('p',{staticClass:"ag-block__description",domProps:{"innerHTML":_vm._s(_vm.$markdown(_vm.synopsis))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }